// $(document).ready(function() {
//   setInterval(() => {
//     $('.widget-layout-grid .rebuy-product-grid .rebuy-product-actions').each(function(){
//       let infoDiv = $(this).siblings('.widget-layout-grid .rebuy-product-grid .rebuy-product-media');
//       $(this).appendTo(infoDiv);
//     })
//   }, 10);
// });
$(document).ready(function() {
  $("a[href^='#pdp-description-section']").click(function(e) {
    e.preventDefault();
    var position = $('.custom-pdp-description-section').offset().top - 150;
    $("body, html").animate({
      scrollTop: position
    } ,1500 );
    if(!$('.accordion__toggle.custom-pdp-description-section').hasClass('toggle-active') ) {
        $('.accordion__toggle.custom-pdp-description-section').click();
        $('.accordion__toggle.custom-pdp-description-section').addClass("toggle-active");
    }    
  });
  $(".custom-pdp-description-section").click(function(e) {
    if($(this).hasClass('toggle-active') ) {
        $('.accordion__toggle.custom-pdp-description-section').removeClass("toggle-active");
    }  
  });
});